import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const LoginWrapper = styled.div`
  display: block;
  width: 100%;
`;

export const FindPasswordLink = styled(Link)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    span {
      padding-top: 8px;
      color: ${theme.content.hierarchy3};
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -3%;
    }
  `}
`;

export const SignUpLinkBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    p {
      display: block;
      color: ${theme.content.content_light_5};
      ${theme.fontStyle.text.body14_medium}
    }
  `}
`;

export const SignUpLink = styled.span`
  ${({ theme }) => css`
    display: block;
    ${theme.fontStyle.text.body14_bold}
    color: ${theme.themeColor.main_1};
  `}
`;
